// The public newsletter form used by wolven.ai, with no API key required.
export const WAITLIST_FORM_URL =
  'https://app.loops.so/api/newsletter-form/cmt8w5yjv07jx0j0xb78zmd2n';
export const WAITLIST_STORAGE_KEY = 'loops-form-timestamp';
export const WAITLIST_COOLDOWN_MS = 60_000;
export const WAITLIST_LABEL = 'Join waitlist';
